const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Frictionless experience from start to finish</h1>
        <p>
          Benefit from our unrivaled payments ecosystem: seamless deposits via
          global and local payment systems, 24/7 access and hassle-free release
          of funds.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
